export default "__VITE_ASSET__CztQq_41__"